"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ambassadorSchema = void 0;
const zod_1 = require("zod");
exports.ambassadorSchema = zod_1.z.object({
    wizefiId: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    createdBy: zod_1.z.string(),
});
